
export default {
   props: {
    paragraph: {
      type: String,
      default: 'false'
    }
    },
  setup () {


    return {
    }
  },
   render() {
    const slot = this.$slots.default
    //  return slot.text.replace(/,/g, "")
    return slot
  }
}
